import React, { useState } from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import GetMonths from '../../Dropdowns/getMonths';
import GetYears from '../../Dropdowns/getYears';



const MonthlySchemeWiseCommodity = () => {
  const [report, setReport] = useState(null);
  const [loadingGenerate, setLoadingGenerate] = useState(false);
  const [message, setMessage] = useState("");
  const [search, setSearch] = useState("");
  const [perPage, setPerPage] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);
  const [showPrintPreview, setShowPrintPreview] = useState(false);
  const [loading, setLoading] = useState(true);
  const [dataTime, setDataTime] = useState("");

  const handleLoadingChange = (isLoading) => {
    setLoading(isLoading);
  };

  const handleSubmit = () => {
    const monthSelect = document.getElementById('month');
    const yearSelect = document.getElementById('year');
    const month = monthSelect.value;
    const year = yearSelect.value;
    const monthName = monthSelect.options[monthSelect.selectedIndex].text; 
    if (month == 0 || month == null || month == '') {
      alert('Please select Month');
    } else if (year == 0 || year == null || year == '') {
      alert('Please select Year');
    } else {
      fetchReport(month, year, monthName);
    }
  };

  const fetchReport = async (month, year, monthName) => {
    try {
      setLoadingGenerate(true);
      setReport(null);
      setMessage("");
      const res = await axios.post(`${process.env.REACT_APP_URL_SALE}/api/sales/monthly`, {
        month,
        year,
      }, { withCredentials: true });
      if (res.data && res.data.rows && res.data.rows.length > 0) {
        const grouped = res.data.commodities.reduce((acc, c) => {
          if (!acc[c.scheme]) acc[c.scheme] = [];
          acc[c.scheme].push(c);
          return acc;
        }, {});

        const calculatedTotals = {};
        res.data.commodities.forEach(c => {
          const key = `comm_code_${c.commCode}_${c.scheme}`;
          calculatedTotals[key] = res.data.rows.reduce((sum, row) => sum + (Number(row.commoditySales?.[key]) || 0), 0);
        });

        let dTime = res.data.dataTime || res.data.data_time || res.data.datatime || "";
        if (!dTime && res.data.rows && res.data.rows.length > 0) {
          const dTimeItem = res.data.rows.find(row => row.dataTime || row.datatime || row.data_time || row.DATA_TIME);
          dTime = dTimeItem ? (dTimeItem.dataTime || dTimeItem.datatime || dTimeItem.data_time || dTimeItem.DATA_TIME) : "";
        }
        if (dTime) {
          try {
            const date = new Date(dTime);
            if (!isNaN(date.getTime())) {
              const day = String(date.getDate()).padStart(2, '0');
              const monthVal = String(date.getMonth() + 1).padStart(2, '0');
              const yearVal = date.getFullYear();
              let hours = date.getHours();
              const minutes = String(date.getMinutes()).padStart(2, '0');
              const seconds = String(date.getSeconds()).padStart(2, '0');
              const ampm = hours >= 12 ? 'PM' : 'AM';
              hours = hours % 12 || 12;
              const strHours = String(hours).padStart(2, '0');
              dTime = `${day}-${monthVal}-${yearVal} ${strHours}:${minutes}:${seconds} ${ampm}`;
            }
          } catch (e) {
            dTime = dTime.replace('T', ' ').substring(0, 19);
          }
        }
        setDataTime(dTime);

        setReport({ ...res.data, totals: res.data.totals || calculatedTotals, dataTime: dTime, monthName, groupedCommodities: grouped });
        setCurrentPage(1);
        setSearch("");
        setShowAll(false);
      } else {
        setReport(null);
        setMessage(`No Data Found for ${monthName} '${year}`);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setMessage("Error fetching data. Please try again.");
    } finally {
      setLoadingGenerate(false);
    }
  };

  const normalize = (value) => {
    if (value == null) return "";
    const num = Number(value);
    return isNaN(num) ? String(value).toLowerCase() : String(num);
  };
  const filteredRows = report?.rows.filter(row => {
    const searchText = normalize(search);
    const rowValues = [
      row.district,
      row.afsoName,
      row.fpsId,
      ...Object.values(row.commoditySales)
    ];
    const rowString = rowValues
      .map(v => normalize(v))
      .join(" ")
      .toLowerCase();
    return rowString.includes(searchText);
  }) || [];
  const totalPages = showAll ? 1 : Math.ceil(filteredRows.length / perPage);
  const startIndex = showAll ? 0 : (currentPage - 1) * perPage;
  const endIndex = showAll ? filteredRows.length : Math.min(startIndex + perPage, filteredRows.length);
  const paginatedRows = filteredRows.slice(startIndex, endIndex);
 const exportToExcel = (tableID, filename = '') => {
  const table = document.getElementById(tableID);
  const tableClone = table.cloneNode(true);
  
  tableClone.querySelectorAll('td, th').forEach(cell => {
    cell.setAttribute('style', 'mso-number-format:"\\@"; text-align: center;');
  });
  tableClone.querySelectorAll('.tableheader th').forEach(th => {
    th.setAttribute('style', 'background-color: #f1872bff; color: black; font-weight: bold; text-align: center; mso-number-format:"\\@";');
  });
  tableClone.querySelectorAll('thead th').forEach(th => {
    th.setAttribute('style', 'background-color: #f1872bff; color: black; font-weight: bold; text-align: center; mso-number-format:"\\@";');
  });
  
  const totalRow = tableClone.querySelector('.tableheader:last-child');
  if (totalRow) {
    totalRow.querySelectorAll('td').forEach(td => {
      td.setAttribute('style', 'background-color: #f1872bff; color: black; font-weight: bold; text-align: right; mso-number-format:"\\@";');
    });
  }
  
  const tableHTML = tableClone.outerHTML.replace(/(\r\n|\n|\r)/gm, '');
  filename = filename ? filename + '.xls' : 'Monthly_Commodity_Sales.xls';
  const htmlContent = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
          xmlns:x="urn:schemas-microsoft-com:office:excel"
          xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta charset="UTF-8">
        <!--[if gte mso 9]>
        <xml>
            <x:ExcelWorkbook>
                <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>Monthly Sales</x:Name>
                        <x:WorksheetOptions>
                            <x:Print>
                                <x:ValidPrinterInfo/>
                            </x:Print>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                </x:ExcelWorksheets>
            </x:ExcelWorkbook>
        </xml>
        <![endif]-->
        <style>
          th {
            background-color: #f1872bff !important;
            color: black !important;
            font-weight: bold !important;
          }
        </style>
    </head>
    <body>
        ${tableHTML}
    </body>
    </html>`;
  const blob = new Blob([htmlContent], {
    type: 'application/vnd.ms-excel;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
  const printPreview = () => {
    if (!report || !report.rows || report.rows.length === 0) {
      alert("No data available to print.");
      return;
    }
    setSearch("");
    setShowAll(true);
    setCurrentPage(1);
    setShowPrintPreview(true);
  };
  const colNCount = report?.commodities.filter(c => c.scheme === "N").length || 0;
  const colSCount = report?.commodities.filter(c => c.scheme === "S").length || 0;
  const printButtonStyle = {
    background: "#3c4fbdff",
    color: "white",
    textDecoration: "underline",
    marginLeft: "30px",
    border: "none",
    padding: "4px 12px",
    borderRadius: "4px",
    cursor: "pointer"
  };
  if (showPrintPreview && report) {
    return (
      <div align="center" style={{ minHeight: "100vh" }}>
        <style>{`
          @media print {
            body * { visibility: hidden; }
            #print-content, #print-content * { visibility: visible; }
            #print-content { position: absolute; left: 0; top: 0; width: 100%; }
            .top-button { display: none !important; }
            .print-buttons { display: none !important; }
          }
        `}</style>
        <div id="print-content">
          <div id="detailsER" style={{ marginTop: "15px" }}>
            <table width="65%" id="Report" border="1">
              <thead style={{ position: "sticky", top: 0 }}>
                <tr className="tableheader">
                  <th colSpan={4 + report.commodities.length}>
                    Monthly Distribution Sale for {report.monthName} ' {report.year}
                  </th>
                </tr>
                <tr className="tableheader">
                  <th rowSpan={2}>Sl No</th>
                  <th rowSpan={2}>District</th>
                  <th rowSpan={2}>AFSO Name</th>
                  <th rowSpan={2}>FPS Id</th>
                  {colNCount > 0 && <th colSpan={colNCount}>NFSA</th>}
                  {colSCount > 0 && <th colSpan={colSCount}>State</th>}
                </tr>
                <tr className="tableheader">
                  {report.commodities.map((c, idx) => (
                    <th key={idx}>{c.commName}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {report.rows.map((row, index) => (
                  <tr key={row.slNo || index}>
                    <td align="right">{index + 1}</td>
                    <td align="center">{row.district}</td>
                    <td align="center">{row.afsoName}</td>
                    <td align="center">{row.fpsId}</td>
                    {report.commodities.map((c) => {
                      const key = `comm_code_${c.commCode}_${c.scheme}`;
                      return (
                        <td key={key} align="right">
                          {Number(row.commoditySales[key] || 0).toFixed(3)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr className="tableheader">
                  <td align="center" colSpan={4}>Total</td>
                  {report.commodities.map((c) => {
                    const key = `comm_code_${c.commCode}_${c.scheme}`;
                    return (
                      <td key={key} align="right">
                        {Number(report.totals[key] || 0).toFixed(3)}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
            {dataTime && (
              <div style={{ width: "65%", textAlign: 'right', marginTop: '10px', fontWeight: 'bold' }}>
                Last Refresh Time: {dataTime}
              </div>
            )}
            <div className="print-buttons" style={{ width: "65%", marginTop: "10px", textAlign: "center" }}>
              <button
              className="button button2"
                onClick={() => window.print()}
              style={{ marginRight: "7px" }}>
                Print
              </button>
              <button
               className="button button2"
                onClick={() => {
                  setShowPrintPreview(false);
                  setShowAll(false);
                }}
              >
                Close
              </button>
            </div>
            <br /><br />
          </div>
        </div>
        <button
          className="top-button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          style={{
            position: "fixed",
            right: "18px",
            bottom: "18px",
            zIndex: 9999,
            backgroundColor: "#f1872bff",
            color: "#100d0dff",
            border: "none",
            padding: "12px 14px",
            borderRadius: "20px",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            cursor: "pointer"
          }}
          title="Go to Top"
        >
          Top
        </button>
        <br /><br /><br /><br />
      </div>
    );
  }
  return (
    <div align="center" style={{ minHeight: "100vh" }}>
      <table border="1" width="55%" style={{ marginBottom: "40px" ,marginTop: "15px" }}>
        <tbody>
          <tr className="tableheader">
            <th colSpan={4}>Monthly Distribution Sale</th>
          </tr>
          <tr>
            <td>Distribution Month</td>
            <td><GetMonths input_id={"month"} onLoadingChange={handleLoadingChange} /></td>
            <td>Distribution Year</td>
            <td><GetYears input_id={"year"} onLoadingChange={handleLoadingChange} /></td>
          </tr>
          <tr>
            <td colSpan={4} align="center">
              <button className="button button2" onClick={handleSubmit} disabled={loading || loadingGenerate} style={{ marginRight: "7px" }}>
                Submit
              </button>
              <button onClick={() => window.history.back()} className="button button2">
                Back
              </button>
            </td>
          </tr>
        </tbody>
      </table>
 
      {loadingGenerate && (
        <div
          align="center"
          id="loading"
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px"
          }}
        >
          <CircularProgress />
        </div>
      )}
      {message && (
        <div
          className="mainhead"
          align="center"
          style={{
            marginTop: "20px",
            color: "brown",
            fontWeight: "bold",
          }}
        >
          {message}
        </div>
      )}
      {report && !loadingGenerate && !showPrintPreview && (
        <>
          <div style={{ width: "65%", marginBottom: "10px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ flex: 1, textAlign: "center" }}>
              <span>per page </span>
              <select
                value={showAll ? "All" : perPage}
                onChange={(e) => {
                  if (e.target.value === "All") {
                    setShowAll(true);
                  } else {
                    setShowAll(false);
                    setPerPage(Number(e.target.value));
                  }
                  setCurrentPage(1);
                }}
                style={{ margin: "0 5px" }}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value="All">All</option>
              </select>
              <button
                onClick={printPreview}
                style={printButtonStyle}
              >
                Print
              </button>
            </div>
          </div>
          <div style={{
            width: "65%",
            marginBottom: "15px",
            display: "flex",
            justifyContent: "flex-end"
          }}>
            <div style={{
              position: "relative",
              display: "inline-block",
              textAlign: "right"
            }}>
              <span style={{ marginRight: "5px" }}>Search</span>
              <input
                type="text"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                }}
                style={{
                  paddingRight: "25px",
                }}
              />
              {search && (
                <span
                  onClick={() => {
                    setSearch("");
                    setCurrentPage(1);
                  }}
                  style={{
                    position: "absolute",
                    right: 6,
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "12px",
                    userSelect: "none",
                  }}
                  title="Clear Search"
                >
                  ✖
                </span>
              )}
            </div>
          </div>
          <div id="detailsER" >
            <table width="65%" id="Report" border="1">
              <thead style={{ position: "sticky", top: 0 }}>
                <tr className="tableheader">
                  <th colSpan={4 + report.commodities.length}>
                    Monthly Distribution Sale for {report.monthName} ' {report.year}
                  </th>
                </tr>
                <tr className="tableheader">
                  <th rowSpan={2}>Sl No</th>
                  <th rowSpan={2}>District</th>
                  <th rowSpan={2}>AFSO Name</th>
                  <th rowSpan={2}>FPS Id</th>
                  {colNCount > 0 && <th colSpan={colNCount}>NFSA</th>}
                  {colSCount > 0 && <th colSpan={colSCount}>State</th>}
                </tr>
                <tr className="tableheader">
                  {report.commodities.map((c, idx) => (
                    <th key={idx}>{c.commName}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {paginatedRows.map((row, index) => (
                  <tr key={row.slNo}>
                    <td align="right">{startIndex + index + 1}</td>
                    <td align="center">{row.district}</td>
                    <td align="center">{row.afsoName}</td>
                    <td align="center">{row.fpsId}</td>
                    {report.commodities.map((c) => {
                      const key = `comm_code_${c.commCode}_${c.scheme}`;
                      return (
                        <td key={key} align="right">
                          {Number(row.commoditySales[key] || 0).toFixed(3)}
                        </td>
                      );
                    })}
                  </tr>
                ))}
                <tr className="tableheader">
                  <td align="center" colSpan={4}>Total</td>
                  {report.commodities.map((c) => {
                    const key = `comm_code_${c.commCode}_${c.scheme}`;
                    return (
                      <td key={key} align="right">
                        {Number(report.totals[key] || 0).toFixed(3)}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
            {dataTime && (
              <div style={{ width: "65%", textAlign: 'right', marginTop: '10px', fontWeight: 'bold' }}>
                Last Refresh Time: {dataTime}
              </div>
            )}
            <div style={{ width: "65%", marginTop: "10px", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "0" }}>
              <div style={{ color: "#792020ff", fontWeight: "bold", textAlign: "left", flex: 1 }}>
                Showing {filteredRows.length > 0 ? startIndex + 1 : 0} to {endIndex} of {filteredRows.length} entries
              </div>
              {!showAll && (
                <div style={{ textAlign: "right", flex: 1, whiteSpace: "nowrap" }}>
                  <button
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                    style={pageBtn}
                  >
                    First
                  </button>
                  <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                    style={pageBtn}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages)].map((_, i) => {
                    if (
                      i === 0 ||
                      i === totalPages - 1 ||
                      (i >= currentPage - 2 && i <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={i}
                          onClick={() => setCurrentPage(i + 1)}
                          style={{
                            ...pageBtn,
                            background: currentPage === i + 1 ? "black" : "#3c4fbdff"
                          }}
                        >
                          {i + 1}
                        </button>
                      );
                    } else if (i === currentPage - 3 || i === currentPage + 2) {
                      return <span key={i} style={{ marginRight: "5px" }}>...</span>;
                    }
                    return null;
                  })}
                  <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={pageBtn}
                  >
                    Next
                  </button>
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                    style={pageBtn}
                  >
                    Last
                  </button>
                </div>
              )}
            </div>
            <div style={{ width: "65%", marginTop: "10px", textAlign: "center" }}>
              <button
                className="button button2"
                onClick={() => exportToExcel('Report', 'Monthly_Commodity_Sales_Details')}
                style={{ marginTop: '10px' }}
              >
                Data To Excel
              </button>
            </div>
            <br /><br />
          </div>
        </>
      )}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        style={{
          position: "fixed",
          right: "18px",
          bottom: "18px",
          zIndex: 9999,
          backgroundColor: "#f1872bff",
          color: "#100d0dff",
          border: "none",
          padding: "12px 14px",
          borderRadius: "20px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          cursor: "pointer"
        }}
        title="Go to Top"
      >
        Top
      </button>
      <br /><br /><br /><br />
    </div>
  );
};
const pageBtn = {
  background: "#3c4fbdff",
  color: "white",
  textDecoration: "underline",
  marginRight: "5px",
  padding: "2px 7px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer"
};
export default MonthlySchemeWiseCommodity;